import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './edm-network-sinker/HeroSection';
import { BreadcrumbSection } from './edm-network-sinker/BreadcrumbSection';
import { DescriptionSection } from './edm-network-sinker/DescriptionSection';
import { ChmerXYZLinearSection } from './edm-network-sinker/ChmerXYZLinearSection';
import { ChmerZLinearSection } from './edm-network-sinker/ChmerZLinearSection';
import { ChmerStandardCNCSection } from './edm-network-sinker/ChmerStandardCNCSection';
import { ChmerLargeCNCSection } from './edm-network-sinker/ChmerLargeCNCSection';
export function EDMNetworkSinkerPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2174">
      <SeoBar data-id="element-2175" />
      <Header data-id="element-2176" />
      <main className="flex-grow" data-id="element-2177">
        <div className="w-full bg-gray-50 pb-20 min-h-screen" data-id="element-2178">
          <HeroSection data-id="element-2179" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2180">
            <BreadcrumbSection data-id="element-2181" />
            <DescriptionSection data-id="element-2182" />
            <div className="space-y-16" data-id="element-2183">
              <ChmerXYZLinearSection data-id="element-2184" />
              <ChmerZLinearSection data-id="element-2185" />
              <ChmerStandardCNCSection data-id="element-2186" />
              <ChmerLargeCNCSection data-id="element-2187" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-2188" />
    </div>;
}